/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import { Button, Checkbox, Form, InputNumber } from "antd";
import DateTimePicker from "../../components/DateTimePicker";
import EditorContainer from "../../components/EditorContainer";
import TableLineIcons from "../../components/TableLineIcons";
import moment from "moment";
import { Job, OutputType, ProcessType, User } from "../../JmReact";


class COTNews extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {

        };

        this.id = "ADMIN_COT_NEWS";

        this.api = {
            get: "get_admin_cot_news",
            create_edit: "create_edit_admin_cot_news",
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21025);
    }

    handleCancel = () => {
        if (this.props.data[this.id].editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id);
        else this.props.dataActions.genericDataCancelEditing(this.id);
    }

    handleOk = () => {
        this.props.dataActions.genericDataSaveEdit(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.create_edit, this.api.get);
    }

    renderEditCol = (text, record) => {
        return (<TableLineIcons onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id, record.key, record.index) }} />)
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
    }

    render() {
        const gt = this.getText;
        const render = t => t
        const sorter = true;
        const { editing, editedRecord, headers, data } = this.props.data[this.id]
        const onChange = data => { this.props.dataActions.genericDataSetEdit(this.id, data) }
        const onChangeActive = (e, i) => {
            let dataSend = headers.join("\f") + "\r" +
                data[i].split("\f").map((x, ii) => ii == 6 ? (e.target.checked ? '1' : '0') : x).join("\f")
            this.sendAPI(this.api.create_edit, dataSend, this.refreshData)
        }

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
            maxWidth: 1200,
            margin: "auto"
        };

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id}
                getApi={this.api.get}
                title={gt(21025)}
                searchBox
                addButton={() => { this.props.dataActions.genericDataStartInlineCreate(this.id) }}
                rowsFilter={r => r.key > 0}
                columns={[
                    { title: gt(21026), key: 'nID', dataIndex: 'nID', width: '8%', sorter, render },
                    { title: gt(21027), key: 'nHeader', dataIndex: 'nHeader', width: '40%', sorter, render: t => (<div dangerouslySetInnerHTML={{ __html: t }} />) },
                    { title: gt(21029), key: 'nDisplayFromDate', dataIndex: 'nDisplayFromDate', width: '14%', sorter, render: t => t ? moment(t).format("DD/MM/YYYY") : "" },
                    { title: gt(21030), key: 'nDisplayToDate', dataIndex: 'nDisplayToDate', width: '14%', sorter, render: t => t ? moment(t).format("DD/MM/YYYY") : "" },
                    { title: gt(21031), key: 'nDisplayOrder', dataIndex: 'nDisplayOrder', width: '8%', sorter, render },
                    { title: gt(21032), key: 'nIsActive', dataIndex: 'nIsActive', width: '8%', sorter, render: (t, r) => (<Checkbox checked={t == 1} onChange={e => { onChangeActive(e, r.index) }} />) },
                    { title: gt(21033), width: '8%', render: this.renderEditCol }
                ]}
            />
            <GenericModal
                visible={editing > -1}
                onCancel={this.handleCancel}
                title={editing == 0 ? gt(21034) : `${gt(21035)} ${editedRecord?.nID}`}
                width={1000}
                footer={[
                    <Button key={"back"} onClick={this.handleCancel} style={{ margin: 5 }}>{gt(21036)}</Button>,
                    <Button key={"create"} type={"primary"} onClick={this.handleOk} style={{ margin: 5 }}>{gt(21037)}</Button>,
                ]}>
                {editing > -1 ? [
                    <Form.Item label={gt(21027)}>
                        <EditorContainer key={"nHeader"} getText={this.getText} topMenu={false} height={200} value={editedRecord.nHeader} onChange={e => { onChange({ nHeader: e }) }} />
                    </Form.Item>,
                    <Form.Item label={gt(21028)}>
                        <EditorContainer key={"nDetails"} getText={this.getText} topMenu={false} value={editedRecord.nDetails} onChange={e => { onChange({ nDetails: e }) }} />
                    </Form.Item>,
                    <Form.Item label={gt(21029)}>
                        <DateTimePicker value={editedRecord.nDisplayFromDate} onChange={e => { onChange({ nDisplayFromDate: e }) }} format={"DD/MM/YYYY"} />
                    </Form.Item>,
                    <Form.Item label={gt(21030)}>
                        <DateTimePicker value={editedRecord.nDisplayToDate} onChange={e => { onChange({ nDisplayToDate: e }) }} format={"DD/MM/YYYY"} />
                    </Form.Item>,
                    <Form.Item label={gt(21031)}>
                        <InputNumber value={editedRecord.nDisplayOrder} onChange={e => { onChange({ nDisplayOrder: e }) }} min={1} max={9999} />
                    </Form.Item>
                ] : ""}
            </GenericModal>
        </div>)
    }

}

export default COTNews;